function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
import { rgba } from "../../../utils/styleUtils";
var buildStyle = function(param, param1) {
    var backgroundColor = param.backgroundColor, font = param.font, depth = param.depth, start = param1.start;
    var _obj, _obj1;
    return {
        wrapper: {
            base: (_obj = {
                position: 'absolute'
            }, _defineProperty(_obj, start.direction, 33), _defineProperty(_obj, "top", 16), _defineProperty(_obj, "background", rgba(backgroundColor.neutral.fill.surface, depth.opacity.heavy)), _defineProperty(_obj, "color", font.color.fill), _defineProperty(_obj, "padding", '2px 8px'), _defineProperty(_obj, "borderRadius", 13), _defineProperty(_obj, "pointerEvents", 'none'), _obj),
            inset: (_obj1 = {}, _defineProperty(_obj1, start.direction, 8), _defineProperty(_obj1, "top", 8), _obj1)
        }
    };
};
var useStyle = function(param) {
    var isRtl = param.isRtl, insetControls = param.insetControls;
    var builtStyle = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    });
    if (!builtStyle) {
        return {
            wrapper: {}
        };
    }
    var wrapper = builtStyle.wrapper;
    return {
        wrapper: _objectSpread({}, wrapper.base, insetControls && wrapper.inset)
    };
};
export default useStyle;
